import { useRouter } from 'next/router'
import { USER_PROFILE_TAB } from 'ui-components'
import { useIsMyProfile } from '~user-profile/hooks/useIsMyProfile'
import { Maps } from './Maps'
import { Settings } from './Settings'
import { Workspaces } from './Workspaces'

const Tab = () => {
  const { query } = useRouter()
  const tab = String(query.tab || USER_PROFILE_TAB.MAPS)
  const isMyProfile = useIsMyProfile()

  return (
    <>
      {tab === USER_PROFILE_TAB.WORKSPACES && <Workspaces />}
      {tab === USER_PROFILE_TAB.MAPS && <Maps />}
      {tab === USER_PROFILE_TAB.SETTINGS && isMyProfile && <Settings />}
    </>
  )
}

export { Tab }
